import React from 'react'
import Figure from './figure'
import './figureMenu.css'

const FigureMenu = ({paths, selectedPath, colors, onClick}) => {
	return (
		<div id="figure-menu">
        <div className="seleccione">Seleccione la figura desea modificar</div>
        <div id="figure-container">
          {paths.map((path, index) => (
            <Figure
              id={index}
              key={index}
              d={path.d}
              width={100}
              height={100}
              strokeWidth='2'
              stroke= "#000"
              independent={true}
              fill={colors[index]}
              selected={index === selectedPath}
              onClick={onClick}
            />
          )
          )}
        </div>
      </div>
	)
}

export default FigureMenu


// WEBPACK FOOTER //
// ./src/components/mosaic/figureMenu.jsx